module.exports = __webpack_public_path__ + "img/decorateMgt.94c3d4c1.svg";